import React, { useEffect, useState } from "react";
import ContactCard from "../../component/ContactCard";
import { Link } from "react-router-dom";
import WodHeroSVG from "../../component/SVGs/WodHeroSVG";
import Image from "../../component/Image";
import { Timeline, TimelineBlock } from "../../component/Timeline";
import Countdown from "../../component/Countdown";

function Opening() {
  const [isCountdownEnded, setIsCountdownEnded] = useState(false);

  useEffect(() => {


    const targetDate = new Date("2026-07-20T00:00:00+07:00");
    const now = new Date();
    setIsCountdownEnded(now >= targetDate);

    const interval = setInterval(() => {
      const currentTime = new Date();
      setIsCountdownEnded(currentTime >= targetDate);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-3 text-center md:text-left max-w-6xl mx-auto w-full px-5 sm:px-8 my-16">
      <div className="flex items-center flex-col md:flex-row gap-3 py-8">
        <div className="flex flex-col gap-3">
          <div data-aos="fade-up">
            <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
              CABANG KEGIATAN
            </div>
            <div className="text-5xl md:text-6xl font-bold">
              <span className="text-arsen-quaternary">O</span>pening{" "}
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            className="bg-arsen-quaternary-100 text-arsen-quaternary rounded-full md:w-fit px-4 py-1 font-medium text-sm"
          >
            Ceremony and Talkshow
          </div>
          <div data-aos="fade-up" data-aos-delay="400">
            <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
              TEMA KEGIATAN
            </div>
            <div className="text-sm md:text-lg leading-6 text-gray-700">
              Finding Certainty in an Uncertain World: Training Ourselves to Find the Signal in a World Full of Noise
            </div>
          </div>
          {isCountdownEnded && (
            <div
              data-aos="fade-up"
              data-aos-delay="600"
              className="flex flex-col md:flex-row gap-2.5 text-md md:text-lg text-center md:text-left text-white mb-8"
            >
              <Link
                to="https://bit.ly/PendaftaranOpeningARSEN2026"
                target="_blank"
                className="bg-arsen-quaternary text-center md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
              >
                Pendaftaran
              </Link>
              <a
                href="#timeline"
                className="text-arsen-quaternary text-center border border-arsen-quaternary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
              >
                Timeline
              </a>
            </div>
          )}
          <div data-aos="fade-up" data-aos-delay="800" className="mt-4">
            <Countdown
              targetDate="2026-07-20T00:00:00+07:00"
              title="Countdown Pembukaan Pendaftaran (20 Juli 2026)"
            />
          </div>
        </div>
        <div
          data-aos="fade-up"
          className="md:ml-4 text-white text-center justify-center"
        >
          <WodHeroSVG width="400" height="auto" />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-8 mb-8">
        <div data-aos="zoom-in" className="flex-1">
          <div className="font-bold text-sm tracking-widest text-gray-600 uppercase mb-4">
            TENTANG KEGIATAN
          </div>
          <div className="text-justify text-gray-700 text-md mb-6">
            Salah satu tema Airlangga Statistics Event (ARSEN) tahun ini bertajuk{" "}
            <b>Finding Certainty in an Uncertain World: Training Ourselves to Find the Signal in a World Full of Noise.</b>{" "}
            Melalui tema ini, peserta diajak untuk memahami bahwa kepastian tidak selalu berarti memiliki semua jawaban, melainkan keberanian untuk berpikir kritis, memahami berbagai perspektif, dan menemukan makna di balik setiap fenomena. Di tengah dunia yang dipenuhi arus informasi dan ketidakpastian, ARSEN hadir sebagai ruang untuk melatih kemampuan mengenali signal di tengah noise melalui berbagai diskusi dan pengalaman yang inspiratif. Dengan demikian, peserta diharapkan mampu mengembangkan pola pikir yang lebih analitis, adaptif, dan bijaksana dalam menghadapi tantangan serta mengambil keputusan di masa depan.
          </div>
        </div>

        <div data-aos="zoom-in" className="flex-1 flex justify-center">
          <div className="w-full max-w-md">
            <div className="font-bold text-sm tracking-widest text-gray-600 uppercase mb-4 text-center">
              POSTER KEGIATAN
            </div>
            <Image
              src="/assets/img/talkshow-poster.jpg"
              alt="Opening Talkshow Poster"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>

      <div
        data-aos="zoom-in"
        className="flex flex-col items-center gap-4 mb-8 p-8 bg-gray-50 rounded-lg"
      >
        <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
          BIAYA PENDAFTARAN
        </div>
        <div className="text-center">
          <div className="text-6xl font-bold text-arsen-quaternary mb-2">
            FREE HTM!!!
          </div>
          <div className="text-2xl font-bold text-gray-700 mb-4">
            What Are You Waiting For?
          </div>
          <Link
            to="https://bit.ly/PendaftaranOpeningARSEN2026"
            target="_blank"
            className="bg-arsen-quaternary text-white text-lg px-8 py-4 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl inline-block"
          >
            Daftar Sekarang!
          </Link>
        </div>
      </div>

      <div className="flex flex-col gap-3 mb-4" id="timeline">
        <div
          data-aos="zoom-in"
          className="font-bold text-sm tracking-widest text-gray-600 uppercase"
        >
          TIMELINE OPENING CEREMONY DAN TALKSHOW
        </div>
        <Timeline month={"Juli - Agustus"}>
          <TimelineBlock date="20 Juli 2026">Open Registration</TimelineBlock>
          <TimelineBlock date="13 Agustus 2026">Close Registration</TimelineBlock>
          <TimelineBlock date="15 Agustus 2026">Tanggal Pelaksanaan</TimelineBlock>
        </Timeline>
      </div>

      <div data-aos="fade-right" className="flex flex-col gap-4 my-16">
        <div className="font-bold text-sm tracking-widest text-gray-600 uppercase">
          What are you waiting for?
        </div>
        <div className="flex-col justify-start items-start flex">
          <div className="text-center md:text-left text-black text-[32px] font-bold">
            Daftarkan dirimu segera!
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-2.5 text-sm text-center md:text-left text-white mb-8">
          <Link
            to="https://bit.ly/PendaftaranOpeningARSEN2026"
            target="_blank"
            className="bg-arsen-quaternary text-center md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:shadow-xl"
          >
            Pendaftaran
          </Link>
          <a
            href="#timeline"
            className="text-arsen-quaternary text-center border border-arsen-quaternary md:w-fit px-8 py-3 rounded-lg transition duration-500 hover:bg-black hover:text-white hover:shadow-xl"
          >
            Timeline
          </a>
        </div>
      </div>
      <div data-aos="fade-right">
        <ContactCard event="Opening" />
      </div>
    </div>
  );
}

export default Opening;
